export const API_DATE_FORMAT = 'yyyy-MM-dd';
export const API_MONTH_FORMAT = 'yyyy-MM';
export const API_YEAR_FORMAT = 'yyyy';
export const VIEW_DATE_FORMAT = 'dd.MM.yyyy';
export const VIEW_MONTH_FORMAT = 'LLLL yyyy';
export const VIEW_DATE_TIME_FORMAT = 'dd.MM.yyyy HH:mm';
